import {httpGetProjectAccessCounters, HttpGetProjectAccessCountersOptions} from '@/features/projects/http/projects.http'
import {ProjectAccessCounters} from '@/features/projects/types'
import {QUERY_KEYS} from '@/queryClient'
import {ErrorResponseData} from '@/types'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

interface UseGetProjectAccessCountersOptions {
    urlParams: HttpGetProjectAccessCountersOptions['urlParams']
    options?: Omit<UseQueryOptions<ProjectAccessCounters, AxiosError<ErrorResponseData>>, 'queryKey' | 'queryFn'>
}

export const useGetProjectAccessCounters = ({urlParams, options}: UseGetProjectAccessCountersOptions) => {
    return useQuery({
        queryKey: [QUERY_KEYS.PROJECT_ACCESS_COUNTERS, urlParams],
        queryFn: () => httpGetProjectAccessCounters({urlParams}),
        ...options
    })
}
